'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo from "./app.api.-Pharmacy-App-Update$-App-Update-Info.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$() {
}
export { $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ as $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ };
$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$() {
}
export { $h_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ as $h_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ };
$h_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype = $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype;
$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype.toString__T = (function() {
  return "AppUpdateInfo";
});
$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$AppUpdateInfo = (function(x$0) {
  var ev$14 = x$0.productElement__I__O(0);
  var buildTime$3 = ((ev$14 === null) ? null : ev$14.Lframework_data_FrameworkDateTime__f_ldt);
  return new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dApp$002dUpdate$002dInfo.$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo(buildTime$3);
});
$c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_api_PharmacyAppUpdate$AppUpdateInfo(p);
});
var $d_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$, "app.api.PharmacyAppUpdate$AppUpdateInfo$", ({
  Lapp_api_PharmacyAppUpdate$AppUpdateInfo$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ as $d_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ };
var $n_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$;
function $m_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$() {
  if ((!$n_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$)) {
    $n_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ = new $c_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$();
  }
  return $n_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$;
}
export { $m_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ as $m_Lapp_api_PharmacyAppUpdate$AppUpdateInfo$ };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-App-Update-Info$.js.map
